import axios from 'axios'

const BASE  = import.meta.env.VITE_WP_BASE_URL
const STORE = `${BASE}/wp-json/wc/store/v1`

const storeClient = axios.create({
  baseURL:         STORE,
  withCredentials: true,
  headers:         { 'Content-Type': 'application/json' },
})

let _nonce = null

async function fetchNonce() {
  const { data } = await axios.get(`${BASE}/wp-json/farafeero/v1/wc-nonce`, {
    withCredentials: true,
  })
  _nonce = data.nonce
  return _nonce
}

async function getNonce() {
  return _nonce ?? (await fetchNonce())
}

async function mutate(method, url, data = {}) {
  const nonce = await getNonce()
  try {
    const res = await storeClient.request({
      method,
      url,
      data,
      headers: { 'X-WC-Store-API-Nonce': nonce },
    })
    return res.data
  } catch (err) {
    if (err.response?.status === 403) {
      _nonce = null // invalidate; caller can retry
    }
    throw err
  }
}

export const getCart       = ()                   => storeClient.get('/cart').then(r => r.data)
export const addToCart     = (id, quantity = 1)   => mutate('POST', '/cart/add-item',   { id, quantity })
export const removeFromCart = (key)               => mutate('POST', '/cart/remove-item', { key })
export const updateCartItem = (key, quantity)     => mutate('POST', '/cart/update-item', { key, quantity })

export async function placeOrder(billingAddress, paymentMethod = 'cod', customerNote = '') {
  const nonce = await getNonce()
  const { data } = await storeClient.post('/checkout', {
    billing_address:  billingAddress,
    shipping_address: billingAddress,
    payment_method:   paymentMethod,
    customer_note:    customerNote,
  }, {
    headers: { 'X-WC-Store-API-Nonce': nonce },
  })
  return data
}
